import storage from 'redux-persist/lib/storage/session';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['user'],
};

export default persistConfig;
